import {
  Button,
  DatePickerWithInput,
  HeadingGroup,
  ModalLayout,
  OffCanvasLayout,
  Pagination,
} from "@wac-ui-dashboard/wac_component_library";
import React from "react";
import { FaSort } from "react-icons/fa";
import Select from "react-select";
import Style from "../report.module.scss";
import { Table } from "../../Global/Table";
import EmptyData from "../../Global/EmptyData";
import FilterButton from "../../Global/FilterButton";
import OrderColumn from "../../Global/OrderColumn";
import Filter from "./Filter";
import useCertificateReport from "./useCertificateReport";

const CertificateReport = () => {
  const {
    date,
    formik,
    loading,
    isLoading,
    isFetching,
    orderTypes,
    tableFields,
    showEditModal,
    filterCount,
    certificateState,
    certificateReportData,
    paginationOptions,
    getRow,
    refetch,
    handleSort,
    handleSearch,
    handleExport,
    handlePageSize,
    handlePagination,
    handleDateChange,
    handleFilterClick,
    handleClearClick,
    updateReportFields,
    handleEditColumnsClick,
  } = useCertificateReport();

  return (
    <div>
      <HeadingGroup title={"Certificate Report"} className={`pro-mb-4`} />
      <div className="col-auto pro-pt-3 pro-pb-6">
        <div className="col-12">
          <div className="row gx-2 gy-2">
            <div className={`col-auto ${Style.pt_24} ${Style.search_wrapper}`}>
              <div className="input-wrap">
                <input
                  type="text"
                  value={certificateState?.search}
                  onChange={handleSearch}
                  placeholder="Search GLI Number, Certificate Number"
                  className={`pro-input icon-r lg search-input`}
                />
                <span className="pro-icon">
                  {<span className="material-symbols-outlined">search</span>}
                </span>
              </div>
            </div>
            <div className={`col-auto ${Style.pt_24}`}>
              <DatePickerWithInput
                CalendarOutlineIcon={
                  <span className="material-symbols-outlined">
                    calendar_month
                  </span>
                }
                range={true}
                initialValue={date}
                onDateChange={handleDateChange}
                maxDate={new Date()}
              ></DatePickerWithInput>
            </div>
            <div className={`col-1 ${Style.pt_24}`}>
              <Select
                id="order_type"
                placeholder={"Select"}
                className={"pro-input lg"}
                classNamePrefix="pro-input"
                name="order_type"
                options={orderTypes}
                getOptionValue={(option) => option?.id}
                getOptionLabel={(option) => option?.name}
                value={formik?.values?.order_type}
                onChange={(value) => formik.setFieldValue("order_type", value)}
                menuPlacement="auto"
              />
            </div>
            <div className={`col-auto ${Style.pt_24}`}>
              <button
                className="pro-btn pro-btn-outline pro-h-100"
                onClick={handleEditColumnsClick}
              >
                Edit Columns
              </button>
            </div>
            <div className={`col-auto ${Style.pt_24}`}>
              <button
                className={`pro-btn pro-btn-outline pro-items-center pro-h-100 ${
                  loading ? "loading" : ""
                }`}
                onClick={handleExport}
                disabled={loading}
              >
                <span className="material-symbols-outlined">download</span>
                <span>Export</span>
              </button>
            </div>
            <div className={`col-auto ${Style.pt_24}`}>
              <FilterButton
                onClick={handleFilterClick}
                filterCount={filterCount}
                label="Filters"
              />
            </div>
            <div className={`col-auto ${Style.pt_24}`}>
              <Button
                className={"pro-btn-link lg pro-px-5"}
                onClick={handleClearClick}
              >
                Clear
              </Button>
            </div>
          </div>
        </div>
        <div>
          {certificateReportData?.data?.data?.length > 0 ? (
            <>
              <Table
                multiSelect={false}
                data={certificateReportData?.data?.data || []}
                uniqueID={"id"}
                fields={tableFields}
                SortIcon={<FaSort />}
                handleSort={handleSort}
                getRow={getRow}
                loading={isFetching}
                perpage={certificateState?.currentPageSize}
                assignable={false}
                editable={false}
                deletable={false}
                showCheckBox={false}
              />
              <Pagination
                currentPage={certificateState?.currentPage}
                totalPageCount={Math.ceil(
                  certificateReportData?.data?.total_count /
                    certificateState?.currentPageSize,
                )}
                onPageChange={handlePagination}
                options={paginationOptions}
                onActionChange={handlePageSize}
                center
              />
            </>
          ) : (
            !isLoading && !isFetching && <EmptyData />
          )}
        </div>

        <ModalLayout show={showEditModal} handleClose={handleEditColumnsClick}>
          <div className="pro-m-5">
            <OrderColumn
              title={"Choose which columns you see"}
              refetchData={refetch}
              tableFields={certificateReportData?.data?.fields ?? {}}
              moduleId={certificateReportData?.data?.module_id ?? null}
              updateData={updateReportFields}
            />
          </div>
        </ModalLayout>

        <OffCanvasLayout
          show={certificateState?.showFilter}
          handleClose={handleFilterClick}
          title={"Filter"}
          closeIcon={<span className="material-symbols-outlined"> close </span>}
        >
          <Filter />
        </OffCanvasLayout>
      </div>
    </div>
  );
};

export default CertificateReport;
